import { render, staticRenderFns } from "./BottomParallax.vue?vue&type=template&id=737a7978&scoped=true&"
import script from "./BottomParallax.vue?vue&type=script&lang=js&"
export * from "./BottomParallax.vue?vue&type=script&lang=js&"
import style0 from "./BottomParallax.vue?vue&type=style&index=0&id=737a7978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a7978",
  null
  
)

export default component.exports